import { RecentlyViewedEntityEnum } from '../../constants';

export const getEntityName = (entityEnum: RecentlyViewedEntityEnum, txaId: string) => {
  return `${entityEnum}_${txaId}`;
};
